import "./App.css";
import Home from "./Pages/Home/Home";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "./redux/store";
import InRussia from "./Pages/InRussia/InRussia";
import Risk from "./Pages/Risk/Risk";
import Test from "./Pages/Test/Test";
import TestResults from "./Pages/TestResults/TestResults";
import HIV from "./Pages/HIV/HIV";
import Syphilis from "./Pages/Syphilis/Syphilis";
import Tuberculosis from "./Pages/Tuberculosis/Tuberculosis";
import PAS from "./Pages/PAS/PAS";
import PreDepartureHiv from "./Pages/PreDepartureHIV/PreDepartureHiv";
import PreDepartureSyphilis from "./Pages/PreDepartureSyphilis/PreDepartureSyphilis";
import PreDepartureTuberculosis from "./Pages/PreDepartureTuberculosis/PreDepartureTuberculosis";
import PreDeparturePAS from "./Pages/PreDeparturePAS/PreDeparturePAS";
import MigrantsHiVInfo from "./Pages/MigrantsHIVInfo/MigrantsHiVInfo";
import ShortTermVisits from "./Pages/ShortTermVisits/ShortTermVisits";
import LawExceptions from "./Pages/LawExceptions/LawExceptions";
import RussiaHivMigrantsTripInfo from "./Pages/RussiaHivMigrantsTripInfo/RussiaHivMigrantsTripInfo";
import RussiaHivMigrantsTreatment from "./Pages/RussiaHivMigrantsTreatment/RussiaHivMigrantsTreatment";
import RussiaHivMigrantsAnalysis from "./Pages/RussiaHivMigrantsAnalysis/RussiaHivMigrantsAnalysis";
import HivSelfFoundedTreatment from "./Pages/HivSelfFoundedTreatment/HivSelfFoundedTreatment";
import KnowMoreAboutDiseases from "./Pages/KnowMoreAboutDiseases/KnowMoreAboutDiseases";
import UsefullLinks from "./Pages/UsefullLinks/UsefullLinks";
import InKazakhstan from "./Pages/InKazakhstan/InKazakhstan";
import HIVKazahkstan from "./Pages/HIVKazakhstan/HIVKazakhstan";
import KazakhstanHivTripInfo from "./Pages/KazakhstanHivTripInfo/KazakhstanHivTripInfo";
import KazakhstanHivTreatment from "./Pages/KazakhstanHivTreatment/KazakhstanHivTreatment";
import KazakhstanHivAnalysis from "./Pages/KazakhstanHivAnalysis/KazakhstanHivAnalysis";
import SyphilisKazahkstan from "./Pages/SyphilisKazakhstan/SyphilisKazakhstan";
import PASKazahkstan from "./Pages/PASKazakhstan/PASKazakhstan";
import TuberculosisKazahkstan from "./Pages/TuberculosisKazakhstan /TuberculosisKazakhstan";
import KazakhstanRemoteImigration from "./Pages/KazakhstanRemoteImigration/KazakhstanRemoteImigration";
import CheckupTajikistan from "./Pages/CheckupTajikistan/CheckupTajikistan";
import CheckupKyrgyzstan from "./Pages/CheckupKyrgyzstan/CheckupKyrgyzstan";
import CheckupUzbekistan from "./Pages/CheckupUzbekistan/CheckupUzbekistan";
import InOtherCountries from "./Pages/InOtherCountries/InOtherCountries";
import OtherCountriesDeportationList from "./Pages/OtherCountriesDepartationList/OtherCountriesDeportationList";
import OtherCountriesAdvises from "./Pages/OtherCountriesAdvises/OtherCountriesAdvises";
import OtherCountriesRestrictions from "./Pages/OtherCountriesRestrictions/OtherCountriesRestrictions";
import HivRemoteTreatment from "./Pages/HivRemoteTreatment /HivRemoteTreatment";

function App() {
  const language = useSelector((state: RootState) => state.info.lang);
  return (
    <>
      <BrowserRouter>
        <Routes key={language}>
          <Route path="/" element={<Home />} />
          <Route path="/russia" element={<InRussia />} />
          <Route path="/kazakhstan" element={<InKazakhstan />} />
          <Route path="/otherCountries" element={<InOtherCountries />} />
          <Route path="/risk" element={<Risk />} />
          <Route path="/test" element={<Test />} />
          <Route path="/test/results" element={<TestResults />} />
          <Route path="/russia/hiv/:id" element={<HIV />} />
          <Route path="/kazakhstan/hiv/:id" element={<HIVKazahkstan />} />
          <Route path="/kazakhstan/pas/:id" element={<PASKazahkstan />} />
          <Route
            path="/otherCountries/deportation/:id"
            element={<OtherCountriesDeportationList />}
          />
          <Route
            path="/otherCountries/restrictions"
            element={<OtherCountriesRestrictions />}
          />
          <Route
            path="/otherCountries/advises/:id"
            element={<OtherCountriesAdvises />}
          />
          <Route
            path="/kazakhstan/syphilis/:id"
            element={<SyphilisKazahkstan />}
          />
          <Route
            path="/kazakhstan/tuberculosis/:id"
            element={<TuberculosisKazahkstan />}
          />
          <Route
            path="/kazakhstan/hiv/treatment/remote/:id"
            element={<KazakhstanRemoteImigration />}
          />
          <Route
            path="/russia/pre-departure/hiv/:id"
            element={<PreDepartureHiv />}
          />
          <Route
            path="/russia/pre-departure/syphilis/:id"
            element={<PreDepartureSyphilis />}
          />
          <Route
            path="/russia/pre-departure/tuberculosis/:id"
            element={<PreDepartureTuberculosis />}
          />
          <Route
            path="/russia/pre-departure/pas/:id"
            element={<PreDeparturePAS />}
          />
          <Route path="/russia/syphilis/:id" element={<Syphilis />} />
          <Route path="/russia/tuberculosis/:id" element={<Tuberculosis />} />
          <Route path="/russia/pas/:id" element={<PAS />} />
          <Route
            path="/russia/hiv/migrants/:id"
            element={<MigrantsHiVInfo />}
          />
          <Route path="/russia/hiv/visits/:id" element={<ShortTermVisits />} />
          <Route
            path="/russia/hiv/migrants/trip/:id"
            element={<RussiaHivMigrantsTripInfo />}
          />
          <Route
            path="/russia/hiv/migrants/treatment/:id"
            element={<RussiaHivMigrantsTreatment />}
          />
          <Route
            path="/russia/hiv/migrants/analysis/:id"
            element={<RussiaHivMigrantsAnalysis />}
          />

          <Route
            path="/kazakhstan/hiv/trip/:id"
            element={<KazakhstanHivTripInfo />}
          />
          <Route
            path="/kazakhstan/hiv/treatment/:id"
            element={<KazakhstanHivTreatment />}
          />
          <Route
            path="/kazakhstan/hiv/analysis/:id"
            element={<KazakhstanHivAnalysis />}
          />
          <Route
            path="/russia/hiv/law-exceptions/:id"
            element={<LawExceptions />}
          />
          <Route
            path="/russia/hiv/migrants/treatment/self-founded/:id"
            element={<HivSelfFoundedTreatment />}
          />
          <Route
            path="/russia/hiv/migrants/treatment/remote/:id"
            element={<HivRemoteTreatment />}
          />
          <Route path="/about/diseases" element={<KnowMoreAboutDiseases />} />

          <Route path="/links" element={<UsefullLinks />} />
          <Route path="/checkup/tajikistan" element={<CheckupTajikistan />} />
          <Route path="/checkup/kyrgyzstan" element={<CheckupKyrgyzstan />} />
          <Route path="/checkup/uzbekistan" element={<CheckupUzbekistan />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
